export const environment = {
  production: false,
  baseURL: location.origin,
  // baseURL: 'https://admin.autoecare.com',
  loggingEnabled: true,
  envName: 'development'
};